import { Box } from '@mui/material'
import { styled } from '@mui/system'
import { useTranslation } from 'react-i18next'
import { DamagePins } from './DamagePins'

import { BoxProps } from '@mui/material'
import { Damage } from '../../constants'

interface DamagesContainerWrapperProps extends BoxProps {
  containerForDamageDetails?: boolean
}

const DamagesContainerWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'containerForDamageDetails',
})<DamagesContainerWrapperProps>(({ theme, containerForDamageDetails }) => ({
  height: containerForDamageDetails ? 200 : 160,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  ...(!containerForDamageDetails && { marginBottom: theme.spacing(4) }),
}))

const DamagesContainer = styled('span')(() => ({
  position: 'relative',
}))

const VehiclePlaceholderImage = styled('img')(() => ({
  maxHeight: '160px',
  maxWidth: '316px',
}))

const DamagesOnVehicle = ({
  damages,
  vehiclePlaceholderImage,
  // Optional prop which used almost in all cases except when we want to highlight a damage and show it in DamageDetails
  handleDamagePinClick,
  // Optional prop used only then when we had damage and we should render this component only show current damage as red and other damages gray
  highlightedDamage,
}: {
  damages: Damage[]
  vehiclePlaceholderImage: string
  handleDamagePinClick?: (damage: Damage) => void
  highlightedDamage?: Damage
}) => {
  const { t } = useTranslation()
  return (
    <DamagesContainerWrapper
      {...(highlightedDamage && { containerForDamageDetails: true })}
    >
      <DamagesContainer>
        <DamagePins
          damages={damages}
          {...(handleDamagePinClick && { handleDamagePinClick })}
          {...(highlightedDamage && { highlightedDamage })}
        />
        <VehiclePlaceholderImage
          src={vehiclePlaceholderImage}
          alt={t('alt.vehicle_placeholder')}
        />
      </DamagesContainer>
    </DamagesContainerWrapper>
  )
}

export default DamagesOnVehicle
